/**
 *
 * Vue Components
 *
 */
Vue.component(
    'example-component',
    require('./components/Example.vue')
);

Vue.component(
    'our-values',
    require('./components/Values.vue')
);

/**
 *
 * Root Vue Instance
 *
 */
var app = new Vue({
    el: '#page'
});